import { fromWei, formatTimestamp, formatDuration } from "./ContractDashboard";

/**
 * Small formatting toolkit used by the generated function definitions
 * so contract output reads like numbers a human recognises.
 */
export const fmt = {
  /** 18-decimals wei -> "12.5" */
  amount: (v) => fromWei(v ?? 0),

  /** wei + symbol */
  token: (v, symbol = "") => `${fromWei(v ?? 0)}${symbol ? ` ${symbol}` : ""}`,

  /** raw percent value from the contract */
  percent: (v) => `${v ?? 0}%`,

  bool: (v) => (v === true || v === "true" ? "Yes" : "No"),

  /** unix seconds -> local date string */
  time: (v) => formatTimestamp(v),

  /** seconds -> "1d 2h" */
  duration: (v) => formatDuration(v),

  /** 0x1234…abcd */
  address: (v) =>
    typeof v === "string" && v.length === 42 ? `${v.slice(0, 8)}…${v.slice(-6)}` : String(v ?? "—"),

  /** pretty-print anything else */
  json: (v) => (typeof v === "object" ? JSON.stringify(v, null, 2) : String(v)),

  list: (v) => ((v || []).length ? v.join("\n") : "None"),
};

export default fmt;
